import React, { memo } from "react";
import Spacer from "../../Spacer";
import { useTranslation } from "react-i18next";
import { formatValidatedMeasurement } from "../../../utils/results/validatedRanges";

export default memo(function SpirometryResultRow({
  time,
  date,
  fev1,
  pef,
  onClick,
}) {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col">
      <button
        type="button"
        onClick={onClick}
        className={[
          "w-full text-left",
          "py-2",
          "flex items-center gap-4",
          "bg-transparent",
          onClick ? "cursor-pointer" : "cursor-default",
        ].join(" ")}
        disabled={!onClick}
      >
        {/* Left: timestamp */}
        <div className="shrink-0 w-fit flex flex-col items-center justify-center leading-tight">
          <div>{time}</div>
          <div className="muted-text">{date}</div>
        </div>

        {/* Right: metrics */}
        <div className="flex-1 grid grid-cols-2 gap-3">
          <div className="flex flex-col items-center justify-center">
            <p className=""> {t("results.spiro.fev1", "FEV1")}</p>
            <div className="title-text text-primary">
              {formatValidatedMeasurement("fev1", fev1)}
              <span className="muted-text">
                {" "}
                {t("results.spiro.FEV1Unit", "L")}
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center">
            <p className="m"> {t("results.spiro.pef", "PEF")}</p>
            <div className="title-text text-primary">
              {formatValidatedMeasurement("pef", pef)}
              <span className="muted-text">
                {t("results.spiro.PEFUnit", "L/min")}
              </span>
            </div>
          </div>
        </div>
      </button>

      <Spacer />
    </div>
  );
});
